const _excluded = ["options", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { createSelector } from 'reselect';
import { appendPath, getValue, parentPath, pathComparator } from '@truqc/content-path';
import { clone } from 'ramda';
import { getContent, getStaticContent, getPropOptions } from './simpleSelectors';
import newPathSelector from './newPathSelector';
const getFormatOptions = (state, props) => (props.format || {}).options;
const getFormatOptionsContentPath = (state, props) => (props.format || {}).optionsContentPath;
const isLeafNode = node => !Object.values(node).some(child => typeof child === 'object');
const getSortAscending = (state, props) => (props.format || {}).sortAscending;
const sortCollectionContent = options => options.sort(pathComparator('_created'));
const transform = (tree = {}, parent = null) => {
  Object.keys(tree).forEach(key => {
    const value = tree[key];
    if (typeof value === 'object' && value !== null && value !== undefined) {
      if (isLeafNode(value)) {
        // This preserves the identifier from the original option during transformation
        value.identifier = key;
      }
      transform(value, key);
    }
    if (key === 'children') {
      const options = Object.keys(tree[key]).map(childKey => tree[key][childKey]);
      /* eslint-disable no-param-reassign */
      tree.options = options;
      tree.identifier = parent;
      delete tree[key];
      /* eslint-enable no-param-reassign */
    }
  });
};
const handleCollectionFormat = (tree, newTree = []) => {
  Object.keys(tree).forEach(key => {
    const _tree$key = tree[key],
      {
        options,
        children
      } = _tree$key,
      value = _objectWithoutProperties(_tree$key, _excluded);
    value.identifier = value.identifier || key;
    if (options || children) {
      const optionChildren = handleCollectionFormat(options || children);
      value.options = optionChildren;
    }
    newTree.push(value);
  });
  return sortCollectionContent(newTree);
};

/* eslint-disable-next-line default-param-last */
const unboundSortOptions = (sortAscending = true, options) => {
  if (!sortAscending) {
    return options.reverse();
  }
  return options;
};
export default createSelector([getContent, getStaticContent, newPathSelector, getFormatOptions, getFormatOptionsContentPath, getPropOptions, getSortAscending], (content, staticContent, path, options, optionsContentPath, propOptions, sortAscending) => {
  const sortOptions = unboundSortOptions.bind(this, sortAscending);
  if (propOptions && propOptions.length) return sortOptions(propOptions);
  if (!options && !optionsContentPath) return [];
  if (options) {
    return Array.isArray(options) ? sortOptions(options) : sortOptions(handleCollectionFormat(options));
  }
  // Use parent path when looking up identifier path to properly parse siblings
  const parent = parentPath(path);
  const optionsPath = appendPath(parent, optionsContentPath);
  let result = getValue(optionsPath, content);
  if (result === undefined) {
    result = getValue(optionsPath, staticContent);
  }
  if (!result) {
    return [];
  }
  let transformedTree = result;
  if (JSON.stringify(transformedTree).includes('children')) {
    // Need to transform to an options structure
    transformedTree = clone(transformedTree);
    transform(transformedTree);
  }
  // Options must be objects, with at least an identifier
  const finalValues = sortCollectionContent(Object.keys(transformedTree).filter(id => Object.keys(transformedTree[id]).length > 0).map(id => {
    const value = transformedTree[id];
    return _objectSpread(_objectSpread({}, value), {}, {
      identifier: value.identifier || id
    });
  }));
  return sortOptions(finalValues);
});